export const INITIAL_MINUTE = '00:00'
export const FIRST_MINUTE = '00:01'
export const LAST_MINUTE = '23:59'
